import Vue from "vue";
import { appClass } from "./modules/appClass.js";

Vue.config.productionTip = false;

new appClass();
